import { ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import Modal from "antd/lib/modal/Modal";
import { useEffect, useState } from "react";
import { Locale } from "../../utils";
import Media from "./Media";

import "./AudioUpload.scss";
const i18n = Locale.getInstance();
const AudioUpload = ({ audio, setSelectedAudio }) => {
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [selectedFiles, selectFiles] = useState(false);
  const [selectedAudio, selectAudio] = useState(false);

  useEffect(() => {
    if (audio && audio.length > 0) {
      selectAudio(audio);
    }
  }, [audio]);

  const handleFinishSelection = () => {
    selectAudio(selectedFiles);
    setSelectedAudio(selectedFiles);
    setOpenUploadModal(false);
  };
  const hideModal = () => {
    setOpenUploadModal(false);
  };

  const showConfirm = () => {
    setOpenUploadModal(true);
  };

  if (selectedAudio && selectedAudio.length > 0) {
    audio = selectedAudio[0];
    return (
      <>
        <div className="audio-upload">
          <div className="preview">
            <audio controls src={audio.url} />
          </div>
          <div className="remove">
            <Button
              onClick={() => {
                selectAudio([]);
              }}
            >
              {i18n.t("common.delete")}
            </Button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="audio-upload">
        <div className="upload-button" onClick={showConfirm}>
          <PlusOutlined />
          <div className="ant-upload-text">
            {i18n.t("productEdit.imagesUpload")}
          </div>
        </div>
      </div>

      <Modal
        title={i18n.t("media.selectAudio")}
        open={openUploadModal}
        onOk={handleFinishSelection}
        onCancel={hideModal}
        okText={i18n.t("base.modal.okText")}
        cancelText={i18n.t("base.modal.cancelText")}
        width={880}
      >
        <Media selectFiles={selectFiles} collectionName="audios" />
      </Modal>
    </>
  );
};

export default AudioUpload;
